<template>
  <v-dialog
    v-if="value"
    :value="value"
    @input="$emit('input', $event)"
    width="60vw"
    max-width="1200px"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">広告主担当者登録エラー</span>
      </v-card-title>
      <div v-if="emailAddresses !== undefined && emailAddresses !== null">
        <v-card-text>
          下記の広告主担当者のメールアドレスは、登録できませんでした。<br />
          広告主担当者に登録する場合、システム管理者へお問い合わせください。
        </v-card-text>
        <v-card-text
          v-for="(emailAddress, index) in emailAddresses"
          :key="index"
          >・{{ emailAddress }}
        </v-card-text>
      </div>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EmailAddressesErrorModal',
  props: {
    value: Boolean,
    emailAddresses: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}
</script>

<style></style>
